import { connect, mapReadPretty, mapProps } from "@formily/react";
import { isField } from "@formily/core";
import { useTranslation } from "react-i18next";
import { SliderWithMarks } from "../../../components/fields/base/Slider";

interface Props {
  value: number;
  onChange: (value: number) => void;
  isDisabled?: boolean;
}

export const PlanSlider = ({ value, onChange, isDisabled = false }: Props) => {
  const { t } = useTranslation(["pricingv2"]);
  const pricingMarks = [
    { value: -2, label: t(($) => $.pricingv2["Maximize\nVolume"]) },
    { value: -1, label: t(($) => $.pricingv2["Boost\nVolume"]) },
    { value: 0, label: t(($) => $.pricingv2["Balanced\nStrategy"]) },
    { value: 1, label: t(($) => $.pricingv2["Boost\nMargin"]) },
    { value: 2, label: t(($) => $.pricingv2["Maximize\nMargin"]) },
  ];
  return (
    <SliderWithMarks
      aria-label={t(($) => $.pricingv2["Pricing optimization"])}
      step={1}
      minValue={-2}
      maxValue={2}
      marks={pricingMarks}
      value={value}
      onChange={onChange}
      isDisabled={isDisabled}
    />
  );
};

export const PlanSliderFormily = connect(
  PlanSlider,
  mapProps((props, field) => {
    if (!isField(field)) return props;
    return {
      value: field.value,
      isDisabled: field.disabled,
      onChange: (value) => {
        void field.onInput(value);
      },
    };
  }),
  mapReadPretty((props) => {
    return `${props.value}`;
  }),
);
